import { schema } from 'normalizr';

export const supportingFileSchema = new schema.Entity('supportingFiles');
export const fileSchema = new schema.Entity('files', {
  supportingFiles: [supportingFileSchema],
});
